import { memo, FC } from 'react';
import { DashboardSourceCode } from '..';
import { DashboardJson } from '../../models';

export interface DashboardSourceCodeMemoizedProps {
  isOpen: boolean;
  dashboard: DashboardJson;
}

export const DashboardSourceCodeMemoized: FC<DashboardSourceCodeMemoizedProps> = memo(({ isOpen, dashboard }) => (
  <DashboardSourceCode
    className={`top-16 right-0 h-full w-[800px] p-3 fixed text-gray-900 dark:text-gray-0 bg-default-bg 
                    ${isOpen ? 'translate-x-0' : 'translate-x-full'} 
                    ease-in-out duration-300 overflow-scroll`}
    dashboard={dashboard}
  />
));
